import { Typography } from '@honestica/ui-kit/src';

import { getFilesToBeCleaned } from '@launcher/helpers/desktop';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  CleanOutboxConfirmationModalReduxProps,
  cleanOutboxConfirmationModalConnector,
} from './CleanOutboxConfirmationModal.connector';

function CleanOutboxConfirmationModalComponent(props: CleanOutboxConfirmationModalReduxProps) {
  const { t } = useTranslation();

  const [count, setCount] = useState<number>(0);

  useEffect(() => {
    const fetchFilesCount = async () => {
      try {
        const files = await getFilesToBeCleaned([props.settings.watchPath], 0);
        setCount(files.length);
      } catch (error) {
        console.error('Failed to get files to be cleaned:', error);
        setCount(0);
      }
    };

    fetchFilesCount();
  }, [props.settings.watchPath]);

  return (
    <Typography.Text>
      {count > 0
        ? t('desktopSettings.cleanOutbox.modal.fileNumberWarning', { count })
        : t('desktopSettings.cleanOutbox.modal.fileNumberWarning_zero')}
    </Typography.Text>
  );
}

export const CleanOutboxConfirmationModal = cleanOutboxConfirmationModalConnector(
  CleanOutboxConfirmationModalComponent,
);
